import { Colors } from '../../theme'
import { sharedSummaryTabStyles } from './styles'

export default {
  ...sharedSummaryTabStyles,
  backgroundColor: Colors.Palette.primaryColor,
  color: Colors.Palette.whiteColor,
  '&:hover': {
    backgroundColor: Colors.Palette.primaryColor
  }
}



// WEBPACK FOOTER //
// ./src/styles/tabs/alt-summary.js